export default __webpack_public_path__ + "c5638415c9ca0cf1820776115d5ee28a.png";